import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { filter, includes, lensProp, map, set } from "ramda";
import { getProjectId } from "../common/selectors";
import { useSelector } from "react-redux";
import { notBlank } from "../common/general";

const langs = [
  { value: "eng", id: "english", display: "English", translation: "" },
  { value: "arm", id: "armenian", display: "Armenian", translation: "" },
  { value: "chi", id: "chinese", display: "Chinese", translation: "" },
  { value: "fre", id: "french", display: "French", translation: "" },
  { value: "ger", id: "german", display: "German", translation: "" },
  { value: "kor", id: "korean", display: "Korean", translation: "" },
  { value: "spa", id: "spanish", display: "Spanish", translation: "" },
  { value: "ara", id: "arabic", display: "Arabic", translation: "" },
];

// QNL wants to only show two languages for engkeystopalestine and arkeystopalestine
// Hardcoding until we store languages in the database
const QatarProjectIds = [
  "672605fa-5511-45d0-8cf9-495943b7a74e",
  "11e5115a-f512-402f-99f8-905a27f64f2f",
];
const isQatarProject = projectId =>
  notBlank(projectId) && includes(projectId, QatarProjectIds);
const getQatarLangs = filter(lang => includes(lang.id, ["english", "arabic"]));

// Add new languages to translation files
export const useLanguages = () => {
  const { t } = useTranslation();
  const projectId = useSelector(getProjectId);
  const [languages, setLanguages] = useState([]);
  useEffect(() => {
    const languages = map(
      lang =>
        set(
          lensProp("translation"),
          t(`file_details.languages.${lang.id}`, lang.display),
          lang
        ),
      langs
    );

    setLanguages(
      isQatarProject(projectId) ? getQatarLangs(languages) : languages
    );
  }, [t, projectId]);

  return languages;
};
